
import { CERTIFICATE_PROVIDERS } from "~/config/_constants";

export default {
  name: "CertificationBlock",
  props: {
    data: {
      type: Object,
      default: () => null,
    },
    certificateUrl: {
      type: String,
      default: "",
    },
    provider: {
      type: String,
      default: "",
    },
  },
  computed: {
    contentHtml() {
      const rawContent =
        this.data?.mixedTranslation?.content?.content ||
        this.data?.mixedTranslation?.content ||
        this.data?.content ||
        "";
      if (!rawContent || !this.certificateUrl) {
        return "";
      }
      return rawContent.replace(
        /{{\s*CERTIFICATE_URL\s*}}/g,
        this.certificateUrl
      );
    },
    providerClass() {
      const provider = (this.provider || "").toUpperCase();
      if (provider === CERTIFICATE_PROVIDERS.IGI) {
        return "cert-igi";
      }
      if (provider === CERTIFICATE_PROVIDERS.GIA) {
        return "cert-gia";
      }
      return "";
    },
  },
};
